<template>
  <span style="text-align:left">
    <template v-if="modo == 'new' || modo == 'edit' || modo == 'flow'">
      <crud-tag
        :embedprops="{
          params: { module: getComponentParam('tabela'), action: 'list' },
          query: {
            joinedid: crud.actionid || localvalue,
            joined: getComponentParam('chaveext')
          },
          props: {
            filtro: false,
            gc: false,
            rodape: false,
            titulo: false,
            select: false,
            exportscreen: false,
            exportserver: false
          }
        }"
      />
    </template>

    <template v-if="modo == 'list' || modo == 'view' || modo == 'viewmode'">
      <div :class="{ 'text-xs-center': crud.action == 'list' }">
        <v-card class="blue lighten-5">
          <crud-tag
            :embedprops="{
              params: { module: getComponentParam('tabela'), action: 'list' },
              query: {
                joinedid: row.id || crud.actionid || localvalue,
                joined: getComponentParam('chaveext')
              },
              props: {
                acoes: false,
                filtro: false,
                gc: false,
                rodape: false,
                titulo: false,
                select: false,
                exportscreen: false,
                exportserver: false
              }
            }"
          />
        </v-card>
      </div>
    </template>
  </span>
</template>

<script>
try {
  var _baseComponent = require("@/lib/componente/_base.vue").default;
} catch (err) {
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}
import _ from "lodash";
export default {
  extends: _baseComponent,

  data() {
    return {
      interv: null,
      localvalue:
        this.modo != "filtro" ? -1 * Math.round(Math.random() * 1000000) : null
    };
  },
  methods: {
    preLoad(myval) {
      return myval;
    },
    preUpdate(myval) {
      return myval;
    }
  },

  beforeDestroy() {
    if (this.interv != null) clearInterval(this.interv);
  },
  mounted() {
    setTimeout(() => this.$emit("input", this.localvalue), 500);

    this.interv = setInterval(() => {
      if (
        window.document.querySelector(
          ".class_card_principal  .class_card_principal  > form > button"
        )
      )
        window.document
          .querySelector(".class_card_principal")
          .classList.add("ajl-multiaberto");
      else
        window.document
          .querySelector(".class_card_principal")
          .classList.remove("ajl-multiaberto");
    }, 200);
  }
};
</script>

<style scoped></style>
